export default {
  path: "/dashboard/",
  name: process.env.VUE_APP_DASHBOARD_LAYOUT,
  redirect: { name: process.env.VUE_APP_DASHBOARD_INDEX },
  component: () => import("@/pages/dashboard/Layout.vue"),
  meta: {
    requiresAuth: true,
  },
  children: [
    {
      path: "index",
      name: process.env.VUE_APP_DASHBOARD_INDEX,
      component: () => import("@/pages/dashboard/Index.vue"),
    },
    {
      path: "profile",
      name: process.env.VUE_APP_PROFILE_UPDATE,
      component: () => import("@/pages/dashboard/Profile.vue"),
    },

    {
      path: "change-password",
      name: process.env.VUE_APP_CHANGE_PASSWORD,
      component: () => import("@/pages/dashboard/ChangePassword.vue"),
    },
    //  Sleep till I figure out what you're suppose to be doing!
    //          I put your vue file in the reivew folder
    // {
    //   path: "result/1",
    //   name: process.env.VUE_APP_SYMPTOM_RESULT,
    //   component: () => import("@/pages/dashboard/SymptomResult.vue"),
    //   meta: {
    //     requiresAuth: true,
    //   },
    // },
    {
      path: "*",
      redirect: { name: process.env.VUE_APP_DASHBOARD_INDEX },
    },
  ],
}
